var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "list",
      staticClass: "list",
      class: { empty_list: !_vm.data.list.length }
    },
    [
      _c("div", { ref: "header", staticClass: "header" }, [
        _c("span", [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _c("img", {
          attrs: { src: "/static/menu-notifications.svg" },
          on: {
            click: function($event) {
              _vm.notificationModal = true
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "resize",
              rawName: "v-resize",
              value: _vm.onResize,
              expression: "onResize"
            }
          ],
          ref: "body",
          staticClass: "body",
          class: { empty_body: !_vm.data.list.length },
          style: {
            maxHeight: _vm.bodyHeight
              ? _vm.bodyHeight + "px"
              : "calc(100% - 85px)"
          }
        },
        [
          _vm.data.preloader
            ? _c("PreloaderTable")
            : !_vm.data.preloader && _vm.data.list.length
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _vm._l(_vm.data.list, function(professional) {
                      return [
                        _c("Card", {
                          key: professional.id,
                          attrs: { professional: professional }
                        })
                      ]
                    })
                  ],
                  2
                )
              ])
            : _c("div", { staticClass: "empty" }, [
                _vm._v("\n      Lista vazia.\n    ")
              ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.data.preloader && _vm.data.list.length
        ? _c(
            "div",
            { ref: "footer" },
            [
              _c("v-pagination", {
                attrs: {
                  "total-visible": 5,
                  length: _vm.data.pagination.totalPages
                },
                on: { input: _vm.setPage },
                model: {
                  value: _vm.data.pagination.current,
                  callback: function($$v) {
                    _vm.$set(_vm.data.pagination, "current", $$v)
                  },
                  expression: "data.pagination.current"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Notification", {
        attrs: {
          opened: _vm.notificationModal,
          name: _vm.name,
          status: this.type
        },
        on: {
          close: function($event) {
            _vm.notificationModal = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2dc3320", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2dc3320","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfessionalRegisterFlow/components/List.vue
// module id = null
// module chunks = 